export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[]
  }
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AnswerOption: ['AcoAnswerOption'],
    Automation: [
      'ChargeItemAutomation',
      'DiagnosisAutocorrectionAutomation',
      'DiagnosisAutomation',
      'ModifierAutomation',
      'RemoveChargeItemAutomation',
    ],
    AutomationAction: [
      'DiagnosisAutomationAction',
      'DiagnosisSyncAutomationAction',
      'ManagementAutomationAction',
      'ModifierAutomationAction',
    ],
    BalanceActivity: [
      'CandidPaymentWithoutEncounterDetails',
      'ClaimPatientPayment',
      'DeveloCandidPatientRefund',
      'MedicalBillingPatientPayment',
      'PaymentPlanPayment',
    ],
    BaseAnswerOption: ['AcoAnswerOption'],
    BaseCandidPayment: [
      'CandidPayment',
      'CandidPaymentWithoutEncounterDetails',
      'ClaimPatientPayment',
      'MedicalBillingPatientPayment',
    ],
    BaseOrderAuditHistory: [
      'OrderAuditHistoryAdministered',
      'OrderAuditHistoryComment',
      'OrderAuditHistoryCompleted',
      'OrderAuditHistoryCompletedDigitalScreen',
      'OrderAuditHistoryCreatedExternally',
      'OrderAuditHistoryEdited',
      'OrderAuditHistoryPended',
      'OrderAuditHistoryReceivedResults',
      'OrderAuditHistoryRecordedResults',
      'OrderAuditHistoryRefused',
      'OrderAuditHistoryResultsReviewTaskResolved',
      'OrderAuditHistoryResultsReviewTaskReviewed',
      'OrderAuditHistoryResultsReviewTaskUpdated',
      'OrderAuditHistoryRevoked',
      'OrderAuditHistorySentDigitalScreen',
      'OrderAuditHistorySentFax',
      'OrderAuditHistorySigned',
      'OrderAuditHistoryUpdateSecondaryStatus',
      'OrderAuditHistoryUpdatedExternally',
      'OrderAuditHistoryUpdatedUrgency',
    ],
    BaseScore: ['AcoScore'],
    CalendarEventDetails: ['CalendarEvent', 'CalendarEventDefinition'],
    ClinicalAssistantMessage: [
      'ClinicalAssistantAiMessage',
      'ClinicalAssistantUserMessage',
    ],
    ConditionAutomationAction: ['DiagnosisAutocorrectionAutomationAction'],
    CursorPage: [
      'ClinicalAssistantMessagePage',
      'ContactInformationPage',
      'FamilyChatMessagePage',
      'FamilyMessageCasePage',
      'GuarantorCommentPage',
      'InsuranceCoverageCommentPage',
      'PaginatedCases',
      'PaginatedTasks',
      'PaginatedTasksAuditHistory',
      'PatientPage',
      'StaffMessagePage',
      'UnauthenticatedAppointmentPage',
    ],
    EligibilityCheck: [
      'CustomInsuranceEligibility',
      'InsuranceCoverageEligibility',
      'StediEligibilityCheck',
    ],
    FaxDocument: ['Binary', 'DiagnosticReport'],
    FinancialSummaryAggregation: [
      'FinancialSummaryAggregationByBillingProvider',
      'FinancialSummaryAggregationByClaimType',
      'FinancialSummaryAggregationByCptCode',
      'FinancialSummaryAggregationByLocation',
      'FinancialSummaryAggregationByMonth',
      'FinancialSummaryAggregationByPayer',
      'FinancialSummaryAggregationByQuarter',
      'FinancialSummaryAggregationByRenderingProvider',
      'FinancialSummaryAggregationByVisitProvider',
      'FinancialSummaryAggregationByVisitType',
    ],
    FinancialSummaryAggregationByCptCodeBillingCode: [
      'BillingCode',
      'DirectPatientChargeBillingCode',
    ],
    FinancialSummaryAggregationByPayerCounterparty: [
      'FinancialSummaryAggregationByPayerInsurance',
      'FinancialSummaryAggregationByPayerNonInsurance',
    ],
    Guarantor: ['Patient', 'RelatedPerson'],
    HedisRequirementAction: [
      'HedisAddResultAction',
      'HedisCreateOrderAction',
      'HedisDocumentImmunityAction',
      'HedisOpenOrderAction',
      'HedisOpenVisitAction',
      'HedisRecordHistoricalAction',
      'HedisScheduleVisitAction',
      'HedisViewImmunizationRecordAction',
      'HedisViewResultAction',
      'HedisViewVisitAction',
    ],
    MedicationIframeResponse: [
      'MedicationIframeResponseError',
      'MedicationIframeResponseSuccess',
    ],
    OffsetPage: [
      'AppointmentNotificationPage',
      'BillingCodePage',
      'DiagnosisCodePage',
      'EligibilityCheckOffsetPage',
      'InsuranceReviewAgentRunOffsetPage',
      'PaginatedHedisMeasureEvaluationResults',
      'PaginatedPatientDemographicsAuditRecords',
      'PaginatedVisits',
      'PatientMedicalRecordPage',
      'PaymentNotificationPage',
      'PortalPaginatedPayments',
      'PortalPaginatedRefunds',
      'RelatedPersonPage',
    ],
    OrderAuditHistory: [
      'OrderAuditHistoryAdministered',
      'OrderAuditHistoryComment',
      'OrderAuditHistoryCompleted',
      'OrderAuditHistoryCompletedDigitalScreen',
      'OrderAuditHistoryCreatedExternally',
      'OrderAuditHistoryEdited',
      'OrderAuditHistoryPended',
      'OrderAuditHistoryReceivedResults',
      'OrderAuditHistoryRecordedResults',
      'OrderAuditHistoryRefused',
      'OrderAuditHistoryResultsReviewTaskResolved',
      'OrderAuditHistoryResultsReviewTaskReviewed',
      'OrderAuditHistoryResultsReviewTaskUpdated',
      'OrderAuditHistoryRevoked',
      'OrderAuditHistorySentDigitalScreen',
      'OrderAuditHistorySentFax',
      'OrderAuditHistorySigned',
      'OrderAuditHistoryUpdateSecondaryStatus',
      'OrderAuditHistoryUpdatedExternally',
      'OrderAuditHistoryUpdatedUrgency',
    ],
    Page: [],
    PatientOrRelatedPerson: ['Patient', 'RelatedPerson'],
    PatientTask: [
      'PatientCheckInTask',
      'PatientRegistrationTask',
      'PatientScreeningTask',
    ],
    PaymentTransactionAuditHistory: [
      'AllocationEditedPaymentTransactionAuditHistory',
      'CreatedPaymentTransactionAuditHistory',
      'ReallocatedPaymentTransactionAuditHistory',
      'RefundedPaymentTransactionAuditHistory',
      'TransactionEditedPaymentTransactionAuditHistory',
    ],
    Person: ['Patient', 'RelatedPerson', 'User'],
    PracticeDocument: [
      'BillingDocument',
      'ExternalRequest',
      'PatientEducationDocument',
      'PatientForm',
      'PracticeAdminDocument',
      'PracticeForm',
      'PracticeLetter',
      'ScreeningTool',
    ],
    RefundablePayment: ['ClaimPatientPayment', 'MedicalBillingPatientPayment'],
    ResultsReviewTaskOrigin: [
      'ResultsReviewTaskOriginDirectFileUpload',
      'ResultsReviewTaskOriginDocumentTask',
      'ResultsReviewTaskOriginHealthGorilla',
      'ResultsReviewTaskOriginUnknown',
    ],
    ReviewCase: ['DiagnosticReportReviewCase', 'ResultsReviewCase'],
    Rule: ['AutomationRule', 'CompoundRule'],
    RuleDescription: ['AutomationRule', 'SubRule'],
    Score: ['AcoScore'],
    Service: ['Immunization', 'NoLinkedService', 'Procedure'],
    SubmitClaimResponse: [
      'SubmitClaimResponseFailure',
      'SubmitClaimResponseSuccess',
    ],
    Task: [
      'DiagnosticReportReviewTask',
      'DocumentTask',
      'FamilyMessageTask',
      'InsuranceReviewTask',
      'SchedulingTask',
      'ScreeningTask',
      'StaffMessageTask',
    ],
    TaskAssignee: ['TaskUserPool', 'TaskUserSet', 'User'],
    TaskAuditHistory: [
      'CommentTaskAuditHistory',
      'CreatedTaskAuditHistory',
      'DiagnosticReportResultsReviewedTaskAuditHistory',
      'EligibilityCheckTaskAuditHistory',
      'PatientMessageTaskAuditHistory',
      'RoutedTaskAuditHistory',
      'StatusUpdateTaskAuditHistory',
    ],
    TranscriptSegment: ['TranscriptPauseSegment', 'TranscriptSpeakingSegment'],
    WithOccurredBy: [
      'CommentTaskAuditHistory',
      'CreatedTaskAuditHistory',
      'DiagnosticReportResultsReviewedTaskAuditHistory',
      'EligibilityCheckTaskAuditHistory',
      'RoutedTaskAuditHistory',
      'StatusUpdateTaskAuditHistory',
    ],
    WithOrderAuditHistoryOccurredBy: [
      'OrderAuditHistoryAdministered',
      'OrderAuditHistoryComment',
      'OrderAuditHistoryCompleted',
      'OrderAuditHistoryCompletedDigitalScreen',
      'OrderAuditHistoryEdited',
      'OrderAuditHistoryPended',
      'OrderAuditHistoryReceivedResults',
      'OrderAuditHistoryRecordedResults',
      'OrderAuditHistoryRefused',
      'OrderAuditHistoryResultsReviewTaskResolved',
      'OrderAuditHistoryResultsReviewTaskReviewed',
      'OrderAuditHistoryResultsReviewTaskUpdated',
      'OrderAuditHistoryRevoked',
      'OrderAuditHistorySentDigitalScreen',
      'OrderAuditHistorySentFax',
      'OrderAuditHistorySigned',
      'OrderAuditHistoryUpdateSecondaryStatus',
      'OrderAuditHistoryUpdatedUrgency',
    ],
  },
}
export default result
